import { logOut } from '@store/reducers/userSlice';
import { message } from 'antd';
import axios, { AxiosError } from 'axios';

// 閱讀官方文件以了解為什麼這樣做：https://redux.js.org/faq/code-structure#how-can-i-use-the-redux-store-in-non-component-files
let store: any;

/**
 * 將 Redux store 注入到 API 模組中
 * @param _store Redux store 物件
 */
export function injectStore(_store: any) {
  store = _store;
}

const instance = axios.create({
  baseURL: '/',
  headers: {
    Accept: 'application/json',
    'Accept-Language': 'zh-TW',
  },
});

/**
 * 請求攔截器，用於在發送請求前處理請求配置
 * @param config 請求配置
 * @returns 處理後的請求配置
 */
export function requestConfig(config: any) {
  console.log(`[Api-Req]: ${config.url}`, config);

  // 獲取當前狀態
  const state = store.getState();

  // 從 userSlice 中獲取 accessToken
  const { accessToken } = state.userSlice;

  // 如果 accessToken 存在，將其添加到請求頭
  if (accessToken) {
    config.headers.setAuthorization(`${accessToken}`);
  }

  // 針對 QE 虛擬樁的 API，添加 Debug-Header
  if (
    config.url.includes('/qePileApi') &&
    process.env.NODE_ENV === 'development'
  ) {
    const newConfig = { ...config };
    newConfig.headers['Debug-Header'] = 'https://yds-dev.beseye.com';
    return newConfig;
  }

  return config;
}

/**
 * 響應攔截器，用於在處理響應前進行相應處理
 * @param response 響應對象
 * @returns 處理後的響應對象
 */
export function responseConfig(response: any) {
  try {
    if (!response || !response.data) {
      throw new Error('Response is invalid');
    }

    console.log(`[Api-Res]: ${response.config.url}`, response);

    const { code } = response.data;

    if ([1, 2].includes(code)) {
      localStorage.setItem('longTermAutoLogout', 'true');
      store.dispatch(logOut());
    }

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
}

instance.interceptors.request.use(requestConfig, (error) =>
  Promise.reject(error),
);

instance.interceptors.response.use(responseConfig, (error) => {
  if (error.name === 'AbortError' || error.name === 'CanceledError') {
    console.warn('請求被取消，不做錯誤處理');
    return Promise.reject(error);
  }

  if (error instanceof AxiosError) {
    message.error('連線異常');
  } else {
    message.error(error.message || 'Server Error');
  }

  return Promise.reject(error);
});

export default instance;
